import { render, staticRenderFns } from "./CNAEField.vue?vue&type=template&id=5bc66c67"
import script from "./CNAEField.vue?vue&type=script&lang=js"
export * from "./CNAEField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports